/**
 * Implements input clearing behavior.
 *
 * It can be used by views that render Bootstrap .input-group-addon
 */

import Marionette from "backbone.marionette";

class InputClear extends Marionette.Behavior {
  events() {
    return {
      "click .input-group-addon": "_clearInput",
    };
  }

  _clearInput(e) {
    e.preventDefault();

    // find the target's previous sibling and remove its value
    $(e.currentTarget).prev().val("").focus();
  }
}

export { InputClear as default };
